import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {Lease} from "@features/leasing/lease-upload/lease-upload.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LeaseUploadService {
  constructor(private http: HttpClient) {
  }

  getHeadLeases(): Observable<{ content: Lease[] }> {
    let requestParams = new HttpParams()
      .set('size', '1000')
      .set('page', '0')
      .set('occupancyType', 'SHARED')
      .set('agreementType', 'LEASE');
    return this.http.get<{ content: Lease[] }>(this.baseLeaseUrl, {params: requestParams});
  }

  getSubLeases(parentUuid: string) {
    let requestParams = new HttpParams()
      .set('size', '1000')
      .set('page', '0')
      .set('parentUuid', parentUuid)
      .set('occupancyType', 'SHARED')
      .set('agreementType', 'SUB_LEASE');
    return this.http.get<{ content: Lease[] }>(this.baseLeaseUrl, {params: requestParams});
  }

  get baseLeaseUrl() {
    return environment.apiLeaseHost + `/console/offering/district/leasing/lease-schedule`
  }
}
